import { __assign } from "tslib";
import { NormalizeICancellablePromiseOptions, Reason } from '@lifaon/observables';
import { ExecLastRouteOfRoutesPath } from './exec-last-route-of-routes-path';
import { GetRoutesPathParams } from './get-routes-path-params';
export function ResolveAndExecLastRoute(route, options) {
    var _options = NormalizeICancellablePromiseOptions(options);
    return route.resolve(_options)
        .then(function (routesPath) {
        if (routesPath.length === 0) {
            throw new Reason("Cannot resolve the path '" + _options.path + "'", 'INVALID_PATH');
        }
        else {
            return ExecLastRouteOfRoutesPath(routesPath, __assign(__assign({}, _options), { routesPath: routesPath, params: GetRoutesPathParams(routesPath, _options.path) }));
        }
    });
}
//# sourceMappingURL=resolve-and-exec-last-route.js.map